// Estilos compartidos para unificar la UI con el Dashboard

export const pageBg = {
  minHeight: '100vh',
  background: '#f0f2f5',
  fontFamily: 'Arial, sans-serif'
};

// Tarjetas
export const cardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
};

// Base de botones
const buttonBase = {
  padding: '12px 24px',
  borderRadius: '8px',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 700,
  transition: 'all 0.2s ease',
};

export const palette = {
  green: '#28a745',
  blue: '#007bff',
  cyan: '#17a2b8',
  orange: '#fd7e14',
  teal: '#20c997',
  purple: '#6f42c1',
  indigo: '#667eea',
  violet: '#764ba2',
  gray: '#6c757d',
  red: '#dc3545',
};

export const button = (color = 'blue') => ({
  ...buttonBase,
  backgroundColor: palette[color] || palette.blue,
});

export const smallButton = {
  padding: '8px 12px',
  borderRadius: '8px',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 700,
  textAlign: 'left',
};

// Banner del Dashboard (por si se reutiliza)
export const headerBanner = {
  display: 'flex',
  alignItems: 'center',
  gap: 18,
  background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 55%, #16a34a 100%)',
  color: 'white',
  borderRadius: 16,
  padding: '16px 20px',
  marginBottom: 16,
  boxShadow: '0 10px 24px rgba(14,165,233,0.25)',
  flexWrap: 'wrap',
  minHeight: 80
};
